import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import {
    PaginationModule,
    BsDatepickerModule,
    DatepickerModule,
} from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AlertModule } from 'ngx-bootstrap/alert';
import { RouteReuseStrategy } from '@angular/router';

import { CustomReuseStrategy } from '../common/route.reuse';

//import { ProductListComponent } from './productlist.main';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HttpClientModule } from '@angular/common/http';

import { FileUploadModule } from 'ng2-file-upload';

import { DecimalOnlyDirective } from '../../directives/decimalonly.directive';
import { IntegerOnlyDirective } from '../../directives/integeronly.directive';
import { CurrencyOnlyDirective } from '../../directives/currencyonly.directive';

import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DELIVERERRESOURCE_ROUTER_PROVIDERS } from './delivererresource.routes';
import { DelivererResourceList } from './delivererresource.list';
import { DelivererResourceComponent } from './delivererresource.main';

@NgModule({
    declarations: [
        DelivererResourceList,
        DelivererResourceComponent,
        DecimalOnlyDirective,
        IntegerOnlyDirective,
        CurrencyOnlyDirective,
    ],
    imports: [
        BrowserModule,
        DELIVERERRESOURCE_ROUTER_PROVIDERS,
        FormsModule,
        HttpModule,
        HttpClientModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        FileUploadModule,
        Ng2SearchPipeModule,
        ReactiveFormsModule,
        BsDatepickerModule.forRoot(),
        DatepickerModule.forRoot(),
        MDBBootstrapModule.forRoot(),
    ],
    providers: [
        SiteServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [DelivererResourceComponent],
})
export class DelivererResouceModule {}
